<button phx-icon-button 
        phxIconButtonSize="small" 
        tabindex="0" 
        [phxIcon]="chevronLeftIcon" 
        (click)="onPreviousYear()">
</button>
<span class="phx-web-type-title-small phx-month-picker-header-title">
  {{ year }}
</span>
<button phx-icon-button 
        phxIconButtonSize="small" 
        tabindex="0" 
        [phxIcon]="chevronRightIcon" 
        (click)="onNextYear()">
</button>